/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsMultisiteItemsCtrl
 * @description A report of sales for all companies grouped by Item
 */
angular.module('mercury.modules.reports.multisite')
.controller('ReportsMultisiteItemsCtrl', ["comparetime", "Budgets", "$filter", "multisite", "ReportPosItems", "$q", "reporttime", "$scope", "title", "userinfo", function(comparetime, Budgets, $filter, multisite, ReportPosItems, $q, reporttime, $scope, title, userinfo) {
  title.set('Products');
  multisite.setMultisite(true);

  $scope.results = [];
  $scope.compare = comparetime.time() !== null;
  $scope.graphColumns = [
    {label: 'Product Name', type: 'string', key: 'name'},
    {label: 'Sales', type: 'number', key: 'sales', filter: 'currency'}
  ];

  var itemsResults = {};
  var compareResults = {};
  var allItems = [];
  var itemResultsProcessed = {};
  var compareResultsProcessed = {};

  var updateResults = function() {
    $scope.results = [];

    var totalSales = 0;
    var totalSalesCompare = 0;

    /**
     * This forEach loop is to get the correct totalSales amount for the
     * item calculations dont in the next forEach each.
     * Two forEach in this method is not very efficient so likely could be improved upon
     */
    angular.forEach(allItems, function(item) {
      // skip this item if it came from a disabled company
      if (multisite.isCompanyDisabled(item.companyId)) {
        return;
      }

      totalSales += item.sales;
      totalSalesCompare += item.salesCompare;
      return;
    });

    var allItemNames = new Set();
    /**
     * The goal here is to take each item from the allItems list,
     * check if it's valid, then find all other items with the same name and combine them
     * in the results array
     */
    angular.forEach(allItems, function(item) {
      // skip this item if it came from a disabled company
      if (multisite.isCompanyDisabled(item.companyId)) {
        return;
      }

      // If item is already in results array then skip it, as all items
      // with that name have been combined togther and added to the results array
      if (allItemNames.has(item.name)) {
        return;
      }

      // filter out any items from disabled companies
      var filteredItems = $filter('filter')(allItems, function(item) {
        return !multisite.isCompanyDisabled(item.companyId);
      });

      // find all remaining items in the allItems array that share a name with our current item
      var itemGrouped = $filter('filter')(filteredItems, function(filteredItem) {
        return filteredItem.name == item.name;
      });

      // now combine these items, and store the sums in the results array
      var itemCount = $filter('sumof')(itemGrouped, 'count');
      var itemSales = $filter('sumof')(itemGrouped, 'sales');
      var itemSalesCompare = $filter('sumof')(itemGrouped, 'salesCompare');
      var itemCountCompare = $filter('sumof')(itemGrouped, 'countCompare');

      allItemNames.add(item.name);

      $scope.results.push({
        name: item.name,
        count: itemCount,
        countCompare: itemCountCompare,
        sales: itemSales,
        salesCompare: itemSalesCompare,
        average: (itemCount !== 0) ? itemSales / itemCount : 0,
        averageCompare: (itemCountCompare !== 0) ? itemSalesCompare / itemCountCompare : 0,
        percent: totalSales !== 0 ? (itemSales / totalSales) * 100 : 0,
        percentCompare: totalSalesCompare !== 0 ? (itemSalesCompare / totalSalesCompare) * 100 : 0
      });
    });

    $scope.$emit('update.googleChart');
    $scope.$emit('dataTableUpdate');
  };

  var buildReport = function() {
    angular.forEach(userinfo.companies(), function(company) {
      if (multisite.isCompanyDisabled(company.id)) {
        updateResults();
        return;
      }

      if (!itemsResults[company.id]) {
        itemsResults[company.id] = ReportPosItems.getSales(reporttime.start(), reporttime.end(), null, company.id);
      }
      if ($scope.compare && !compareResults[company.id]) {
        compareResults[company.id] = ReportPosItems.getSales(comparetime.start(), comparetime.end(), null, company.id);
      }

      itemsResults[company.id].then(function(itemResult) {
        if (!itemResultsProcessed[company.id]) {
          angular.forEach(itemResult, function(item) {
            allItems.push({
              companyId: company.id,
              name: item.itemName,
              count: item.quantity,
              sales: item.invoices,
              average: item.invoices / item.quantity
            });
          });
          itemResultsProcessed[company.id] = true;
          updateResults();
        }
      });

      if (compareResults[company.id]) {
        compareResults[company.id].then(function(compareResult) {
          if (!compareResultsProcessed[company.id]) {
            angular.forEach(compareResult, function(item) {
              allItems.push({
                companyId: company.id,
                name: item.itemName,
                countCompare: item.quantity,
                salesCompare: item.invoices,
                averageCompare: item.invoices / item.quantity
              });
            });
            compareResultsProcessed[company.id] = true;
            updateResults();
          }
        });
      }
    });
  };

  angular.forEach(userinfo.companies(), function(company) {
    if (multisite.isCompanyDisabled(company.id)) {
      return;
    }

    itemsResults[company.id] = ReportPosItems.getSales(reporttime.start(), reporttime.end(), null, company.id);
    if ($scope.compare) {
      compareResults[company.id] = ReportPosItems.getSales(comparetime.start(), comparetime.end(), null, company.id);
    }
  });

  $scope.loading = $q.all(itemsResults);
  $scope.loading.then(buildReport);
  $scope.$on('userInfoUpdated', buildReport);
}]);
